import { productBySkuResult } from '../../types/assetExporter'

export const searchProductBySku = async (itemNumberValue: string) => {
  if (!itemNumberValue || itemNumberValue.length < 3) {
    return
  }

  const axios = require('axios')
  const response = await axios({
    method: 'GET',
    url: `https://pdassetexporter.azurewebsites.net/api/shopify/productBySku?sku=${itemNumberValue}`,
  })
  return response
}
